module.exports = __webpack_public_path__ + "media/images/features/flexible_and_versatile_img-7edc4f46b53b827958b537c5a741faed.png";